import { createSelector } from 'reselect';

import {
  englishAlternatives,
  ENGLISH,
} from 'config/types/language';

import getLocale from './getLocale';

export const getEditionFromLocale = (locale) => (
  // See docs/in-product-locale.md
  englishAlternatives.includes(locale) ?
    ENGLISH :
    locale
);

export const getEdition = createSelector(
  getLocale,
  getEditionFromLocale,
);
